console.log("js started");

function updateMomentsLayout() {
  const items = document.querySelectorAll("#moments-grid .moments-item");
  const total = items.length;
  const remainder = total % 3;

  // আগে সব responsive class remove
  items.forEach((item) => {
    item.classList.remove(
      "tab:col-start-3",
      "tab:col-start-5",
      "tab:col-start-7",
    );
  });

  // শুধু tablet mode এ apply হবে
  if (window.innerWidth >= 768) {
    if (remainder === 1) {
      items[total - 1]?.classList.add("tab:col-start-5");
    } else if (remainder === 2) {
      items[total - 2]?.classList.add("tab:col-start-3");
      items[total - 1]?.classList.add("tab:col-start-7");
    }
  }
}

// প্রথম load এ run
updateMomentsLayout();

// resize হলেও update হবে
window.addEventListener("resize", updateMomentsLayout);

document.querySelectorAll(".accordion-group").forEach((group) => {
  group.querySelectorAll(".accordion-trigger").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const item = trigger.closest(".accordion-item");
      const body = item.querySelector(".accordion-body");
      const isOpen = item.classList.contains("open");

      // শুধু এই group-এর ভেতরে close করো
      group.querySelectorAll(".accordion-item").forEach((el) => {
        el.classList.remove("open");
        el.querySelector(".accordion-body").classList.remove("open");
        el.querySelector(".accordion-trigger").setAttribute(
          "aria-expanded",
          "false",
        );
      });

      // যদি বন্ধ ছিল তাহলে open করো
      if (!isOpen) {
        item.classList.add("open");
        body.classList.add("open");
        trigger.setAttribute("aria-expanded", "true");
      }
    });
  });
});

// mobile menu scripts

const hamBtn = document.getElementById("ham-btn");
const closeBtn = document.getElementById("close-btn");
const drawer = document.getElementById("mobile-drawer");
const header = document.getElementById("site-header");

function openDrawer() {
  drawer.classList.add("is-open");

  drawer.removeAttribute("inert");

  hamBtn.classList.add("is-open");

  hamBtn.setAttribute("aria-expanded", "true");

  drawer.setAttribute("aria-hidden", "false");

  document.body.style.overflow = "hidden";

  closeBtn.focus();
}

function closeDrawer() {
  hamBtn.focus();

  drawer.classList.remove("is-open");

  drawer.setAttribute("inert", "");

  hamBtn.classList.remove("is-open");

  hamBtn.setAttribute("aria-expanded", "false");

  drawer.setAttribute("aria-hidden", "true");

  document.body.style.overflow = "";
}

hamBtn.addEventListener("click", openDrawer);
closeBtn.addEventListener("click", closeDrawer);

// Close on link click
drawer
  .querySelectorAll("a")
  .forEach((a) => a.addEventListener("click", closeDrawer));

// Close on Escape key
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") closeDrawer();
});

// Close on resize to desktop
window.addEventListener("resize", () => {
  if (window.innerWidth >= 601) closeDrawer();
});

// Scroll shadow
window.addEventListener(
  "scroll",
  () => {
    header.classList.toggle("scrolled", window.scrollY > 8);
  },
  { passive: true },
);

let elements = document.querySelectorAll(".rolling-text");

elements.forEach((element) => {
  let innerText = element.innerText;

  element.innerText = "";

  let textContainer = document.createElement("div");
  textContainer.classList.add("block");

  for (let letter of innerText) {
    let span = document.createElement("span");

    span.innerText = letter === " " ? "\u00A0" : letter;
    span.classList.add("letter");

    textContainer.appendChild(span);
  }

  let clone = textContainer.cloneNode(true);

  element.appendChild(textContainer);
  element.appendChild(clone);
});

let blocks = document.querySelectorAll(".block");

blocks.forEach((block) => {
  Array.from(block.children).forEach((letter, index) => {
    letter.style.transitionDelay = `${index * 0.03}s`;
  });
});
console.log("js complete");
